// const sitehost = window.location.hostname;
export const getPrintingMarginTop = function() {
	// let pagesize = sitehost.includes('pentagol') ? '0px' : '-450px';
	let pagesize = '-450px';
	console.log('receipt-page-size', pagesize);
	return pagesize;
}